import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import PublisherAfterFindForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAfterFindForm'
import { StoresContext } from '@App/contexts'
import { PublisherFormType } from '@App/enum/publisher-form-type'
import PublisherAddForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAddForm'
import PublisherCreateForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm'
import RootStore from '@App/stores/root-store'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface AddOriginalPublisherProps {
    isRHRestricted: boolean
}

const AddOriginalPublisher = ({ isRHRestricted }: AddOriginalPublisherProps) => {
    const { workStore, publisherSearchStore, unrestrictedPublisherSearchStore, publisherStepStore } =
        useContext<RootStore>(StoresContext)
    const selectedSearchStore = isRHRestricted ? publisherSearchStore : unrestrictedPublisherSearchStore

    const addPublisherToDraft = () => {
        publisherStepStore.addOriginalPublisherToDraft()
    }

    const setFinedPublisherToDraft = (publisher: OriginalPublisherModel) => {
        workStore.setFoundOriginalPublisherToDraft(publisher)
    }

    const setOriginalPublisherData = (publisherData: OriginalPublisherModel) => {
        publisherStepStore.setOriginalPublisherData(publisherData)
    }

    useEffect(
        () => () => {
            selectedSearchStore.clearStore()
            publisherStepStore.resetStore()
        },
        [publisherStepStore, selectedSearchStore]
    )

    switch (publisherStepStore.formType) {
        case PublisherFormType.add:
            return (
                <PublisherAddForm
                    searchStore={selectedSearchStore}
                    setFoundPublisherToDraft={setFinedPublisherToDraft}
                    topClass="original-publisher-sub-form-component"
                    title="Add Publisher"
                    subtitle="First, search by publisher name to see if the publisher already exists in your catalog."
                    searchFilterPlaceholder="Search publisher's name"
                    suggestedTitle="Pick from suggested publishers:"
                    buttonText="Create Publisher"
                    isAdministrator={false}
                    isUnrestricted={!isRHRestricted}
                />
            )
        case PublisherFormType.create:
            return (
                <PublisherCreateForm
                    publisherData={publisherStepStore.originalPublisherData}
                    setPublisherData={setOriginalPublisherData}
                    addPublisherToDraft={addPublisherToDraft}
                    topClass="original-publisher-sub-form-component"
                    isAdministrator={false}
                />
            )
        case PublisherFormType.afterFind:
            return (
                <PublisherAfterFindForm
                    searchStore={selectedSearchStore}
                    setFinedPublisherToDraft={setFinedPublisherToDraft}
                    addPublisherToDraft={addPublisherToDraft}
                    topLevelClass="original-publisher-sub-form-component"
                />
            )
    }
}

export default observer(AddOriginalPublisher)
